<template>
  <div class="mconarall">
    <Header :header="header"></Header>
    <!--依照套用參數進入樣板-->
    <MyPage></MyPage>
  </div>
</template>

<script>
import Header from "../../components/admin/NavBar/Header.vue"
import MyPage from "../../components/admin/Content/Home/myPage.vue"
export default{
  components:{
    Header,
    MyPage,
  },
  data(){
    return {
      //標頭
      header:{
        text1:'歡迎頁面',
      },
      //樣式名稱
      currentComponent:null,
      //頁面參數
      querylist:{
          id:"",

      },
      //API
      //帳號管理
      apiUserInfoType: (data) => this.userRequest.post("bicd/UserInfo", data),
    }
  },
  mounted(){
    //初始化
    this.init();
  },
  watch:{
    
  },
  methods:{
    //初始化
    init(){

    },
  }
}
</script>